import { Component, ViewChild, ElementRef } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform } from 'ionic-angular';
import { Constants } from '../../../constants';

/**
 * Generated class for the FichaPhotoRecettePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-ficha-photo-recette',
  templateUrl: 'ficha-photo-recette.html',
})
export class FichaPhotoRecettePage {
  zoom: number = 1;
  image;
  rotationAmount: number = 0;
  @ViewChild('imagen') imagen: ElementRef;
  private ZOOM_MIN: number = .5;
  private ZOOM_MAX: number = 3;
  private ZOOM_STEP: number = .5;
  width: number;
  height: number;
  marginTop: number;
  marginLeft: number;
  maxWidth: number;
  maxHeight: number;
  deviceWidth: number;
  deviceHeight: number;
  diametro: number = 20;

  urlFoto: string = "";

  constructor(public navCtrl: NavController, public navParams: NavParams, private platform: Platform) {

    this.urlFoto = Constants.urlFotos + navParams.data.idMedicion + '/download/recete.jpeg'
    console.log("DATOS ", navParams)
    //    this.image = navParams.data.recipe.recipePicture;
    
    this.image = this.urlFoto;
    platform.ready().then((readySource) => {
      this.deviceWidth = platform.width();
      this.deviceHeight = platform.height();


    });
  }
  ngAfterViewInit() {
    this.imagen.nativeElement.addEventListener('load', () => {
      console.log('load')
      this.resizeImage(this.zoom);
    });
  }

  zoomOut() {
    console.log('zoom Out')
    if (this.zoom == this.ZOOM_MIN) return
    this.zoom -= this.ZOOM_STEP;
    this.resizeImage(this.zoom);
  }

  zoomIn() {
    console.log('zoom In')
    if (this.zoom == this.ZOOM_MAX) return
    this.zoom += this.ZOOM_STEP;
    this.resizeImage(this.zoom);
  }
  ionViewDidLoad() {

    console.log(this.navParams.data);
  }

  resizeImage(zoom: number = 1) {
    this.width = this.imagen.nativeElement.naturalWidth * zoom;
    this.height = this.imagen.nativeElement.naturalHeight * zoom;
    this.marginTop = (this.deviceHeight - this.height) / 2;
    this.marginLeft = (this.deviceWidth - this.width) / 2;
    this.maxWidth = this.width;
    this.maxHeight = this.height;

    //  this.printImageSize();
  }

  public rotar(sense: number) {

    //1 = izq, 0 = der
    this.rotationAmount = (sense > 0) ? this.rotationAmount += -90 : this.rotationAmount += 90;

    var rotation = "rotate(" + this.rotationAmount + "deg)";
    this.imagen.nativeElement.style.transform = rotation;
  }

}



// WEBPACK FOOTER //
// ./src/pages/ficha-tabs/ficha-photo-recette/ficha-photo-recette.ts